import React from 'react';
import { colorForRatio, HEAT_LAYER_OPACITY } from './heatColors';

const STOPS = [0, 0.25, 0.5, 0.75, 1];

export default function HeatLegend({ maxValue = 0, metric = 'count' }) {
    const unit = metric === 'revenue' ? '₽' : 'шт.';

    return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 10 }}>
            <div
                className="delivery-map-heat-legend__label-column"
                style={{ display: 'flex', flexDirection: 'column', minWidth: 90 }}
            >
                <span style={{ fontSize: 12, color: '#595d6e' }}>
                    {metric === 'revenue' ? 'Выручка' : 'Кол-во заказов'}:
                </span>
                <span style={{ fontSize: 11, color: '#595d6e', marginTop: 4 }}>{unit}</span>
            </div>
            <div className="delivery-map-heat-legend__scale-column">
                <div className="delivery-map-heat-legend__colors" style={{ display: 'flex' }}>
                    {STOPS.map((stop) => (
                        <div
                            key={stop}
                            style={{
                                width: 60,
                                height: 14,
                                background: colorForRatio(stop),
                                opacity: HEAT_LAYER_OPACITY
                            }}
                        />
                    ))}
                </div>
                <div
                    className="delivery-map-heat-legend__values"
                    style={{ display: 'flex', fontSize: 11, color: '#595d6e', marginTop: 4 }}
                >
                    {STOPS.map((stop) => (
                        <span key={stop} style={{ width: 60, textAlign: 'center' }}>
                            {Math.round(maxValue * stop).toLocaleString('ru-RU')}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
